import React, {useEffect, useMemo, useRef} from 'react';
import { useSelector } from 'react-redux';
// import { geofenceToFeature } from './mapUtil'; // Assuming this is still needed and works

// Helper function to calculate centroid of a polygon (if geofenceToFeature doesn't provide a point for label)
// This is a very basic centroid calculation, might need a more robust one (e.g., from turf.js)
const getPolygonCentroid = (googleMapsApi, paths) => {
    if (!paths || paths.length === 0) return null;
    let latSum = 0;
    let lngSum = 0;
    let pointCount = 0;

    paths.forEach(path => {
        // For google.maps.Polygon, paths can be an array of LatLngs or an array of arrays of LatLngs (for complex polygons)
        const currentPath = Array.isArray(path) ? path : [path]; // Ensure we're iterating over points
        currentPath.forEach(point => {
            if (point && typeof point.lat === 'function' && typeof point.lng === 'function') {
                latSum += point.lat();
                lngSum += point.lng();
                pointCount++;
            } else if (point && typeof point.lat === 'number' && typeof point.lng === 'number') {
                latSum += point.lat;
                lngSum += point.lng;
                pointCount++;
            }
        });
    });

    if (pointCount === 0) return null;
    return new googleMapsApi.LatLng(latSum / pointCount, lngSum / pointCount);
};

//you can remove all commants.
const GeofenceMapGoogle = ({ map, googleMapsApi }) => {
    const geofencesMap = useSelector(state => state.geofences.items);
    const geofencesData = useMemo(() => Object.values(geofencesMap || {}), [geofencesMap]);

    const mapObjectsRef = useRef({ polygons: [], lines: [], labels: [] }); // Store Google Maps objects

    // Convert geofences from Redux store to GeoJSON features
    // const geoJsonFeatures = React.useMemo(() => {
    //     return geofencesData.map(geofence => geofenceToFeature(geofence)).filter(Boolean);
    //     // .filter(Boolean) removes any null/undefined if geofenceToFeature can return that
    // }, [geofencesData]);


    useEffect(() => {
        // if (!map || !googleMapsApi || !geoJsonFeatures) {
        if (!map || !googleMapsApi) {
            // If map isn't ready or no features, clear existing map objects
            Object.values(mapObjectsRef.current).flat().forEach(obj => obj.setMap(null));
            mapObjectsRef.current = { polygons: [], lines: [], labels: [] };
            return;
        }

        // 1. Clear existing geofence objects from the map
        Object.values(mapObjectsRef.current).flat().forEach(obj => obj.setMap(null));
        const newMapObjects = { polygons: [], lines: [], labels: [] };

        // 2. Process GeoJSON features and add them to the map
        // geoJsonFeatures.forEach(feature => {
        //     if (!feature || !feature.geometry) return;
        //
        //     const name = feature.properties?.name || 'Unnamed Geofence';
        //
        //     // Handle Polygons for fill and line
        //     if (feature.geometry.type === 'Polygon' && feature.geometry.coordinates) {
        //         const googlePaths = feature.geometry.coordinates.map(ring =>
        //             ring.map(coordPair => ({ lat: coordPair[1], lng: coordPair[0] }))
        //         );
        //
        //         // Geofence Fill
        //         const polygonFill = new googleMapsApi.Polygon({
        //             paths: googlePaths,
        //             strokeColor: '#3bb2d0', // Used as outline in Mapbox, here it's the polygon's own stroke
        //             strokeOpacity: 0,       // Make it transparent if only fill is desired with separate line
        //             strokeWeight: 0,
        //             fillColor: '#3bb2d0',
        //             fillOpacity: 0.1,
        //             map: map,
        //         });
        //         newMapObjects.polygons.push(polygonFill);
        //
        //         // Geofence Line (Border)
        //         const polyline = new googleMapsApi.Polyline({
        //             path: googlePaths[0], // Assuming the first ring is the outer boundary for the line
        //             strokeColor: '#3bb2d0',
        //             strokeOpacity: 1.0, // From line-color opacity (default 1)
        //             strokeWeight: 2,    // From line-width
        //             map: map,
        //         });
        //         newMapObjects.lines.push(polyline);
        //
        //         // Geofence Label (Symbol) for Polygons - place at centroid
        //         // For Google Maps, labels are typically attached to Markers.
        //         // We'll create a transparent marker and use its label property.
        //         const centroid = getPolygonCentroid(googleMapsApi, googlePaths[0]);
        //         if (centroid) {
        //             const labelMarker = new googleMapsApi.Marker({
        //                 position: centroid,
        //                 map: map,
        //                 icon: { // Transparent icon
        //                     path: 'M 0,0', // A single point, effectively invisible
        //                     strokeOpacity: 0,
        //                     fillOpacity: 0,
        //                 },
        //                 label: {
        //                     text: name,
        //                     color: '#000000', // Text color (Mapbox default is black unless specified)
        //                     fontSize: '12px',
        //                     fontWeight: 'normal', // Mapbox text-font: ['Roboto Regular'] implies normal weight
        //                     // Google Maps doesn't have direct text-halo-color/width.
        //                     // Advanced labels can be done with custom overlays or the new AdvancedMarkerElement.
        //                     // For simplicity, we're using basic marker labels.
        //                 },
        //                 // To emulate text-halo, you might need a custom HTML overlay or draw on canvas.
        //                 // zIndex can be used if needed, but usually not for simple labels.
        //             });
        //             newMapObjects.labels.push(labelMarker);
        //         }
        //     }
        //     // Handle Points for labels (if geofenceToFeature directly returns a Point for the label)
        //     else if (feature.geometry.type === 'Point' && feature.geometry.coordinates) {
        //         const position = {
        //             lat: feature.geometry.coordinates[1],
        //             lng: feature.geometry.coordinates[0],
        //         };
        //         const labelMarker = new googleMapsApi.Marker({
        //             position,
        //             map,
        //             icon: { path: 'M 0,0', strokeOpacity: 0, fillOpacity: 0 }, // Transparent icon
        //             label: {
        //                 text: name,
        //                 color: '#000000',
        //                 fontSize: '12px',
        //                 fontWeight: 'normal',
        //             },
        //         });
        //         newMapObjects.labels.push(labelMarker);
        //     }
        //     // Handle LineStrings (if geofences can be lines)
        //     else if (feature.geometry.type === 'LineString' && feature.geometry.coordinates) {
        //         const googlePath = feature.geometry.coordinates.map(coordPair => ({
        //             lat: coordPair[1],
        //             lng: coordPair[0],
        //         }));
        //
        //         const polyline = new googleMapsApi.Polyline({
        //             path: googlePath,
        //             strokeColor: '#3bb2d0',
        //             strokeOpacity: 1.0,
        //             strokeWeight: 2,
        //             map: map,
        //         });
        //         newMapObjects.lines.push(polyline);
        //         // Could also add a label to the center of the LineString if needed
        //     }
        // });

        // 2. Process geofencesData directly and add objects to the map
        geofencesData.forEach(geofence => {
            if (!geofence || !geofence.area) return;

            const name = geofence.name || 'Unnamed Geofence';

            // Handle CIRCLE
            if (geofence.area.startsWith('CIRCLE(')) {
                // Parse "CIRCLE(lat lng, radius)"
                const content = geofence.area.substring(7, geofence.area.length - 1);
                const [coordsStr, radiusStr] = content.split(', ');
                const [lat, lng] = coordsStr.split(' ').map(Number);
                const radius = Number(radiusStr);

                if (!isNaN(lat) && !isNaN(lng) && !isNaN(radius)) {
                    // Create the Google Maps Circle object
                    const circle = new googleMapsApi.Circle({
                        strokeColor: '#3bb2d0',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#3bb2d0',
                        fillOpacity: 0.1,
                        map: map,
                        center: { lat, lng },
                        radius: radius, // Radius is in meters
                    });
                    newMapObjects.polygons.push(circle); // Store with polygons for cleanup

                    // Create the label at the center
                    const labelMarker = new googleMapsApi.Marker({
                        position: { lat, lng },
                        map: map,
                        icon: { path: 'M 0,0', strokeOpacity: 0, fillOpacity: 0 },
                        label: {
                            text: name,
                            color: '#000000',
                            fontSize: '12px',
                            fontWeight: 'normal',
                        },
                    });
                    newMapObjects.labels.push(labelMarker);
                }
            }
            // Handle POLYGON
            else if (geofence.area.startsWith('POLYGON((')) {
                // Parse "POLYGON((lat lng, lat lng, ...))"
                const coordsStr = geofence.area.substring(9, geofence.area.length - 2);
                const googlePath = coordsStr.split(', ').map(pair => {
                    const [lat, lng] = pair.split(' ').map(Number);
                    return { lat, lng };
                });

                // Geofence Fill
                const polygonFill = new googleMapsApi.Polygon({
                    paths: [googlePath],
                    strokeOpacity: 0,
                    strokeWeight: 0,
                    fillColor: '#3bb2d0',
                    fillOpacity: 0.1,
                    map: map,
                });
                newMapObjects.polygons.push(polygonFill);

                // Geofence Line (Border)
                const polyline = new googleMapsApi.Polyline({
                    path: googlePath,
                    strokeColor: '#3bb2d0',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    map: map,
                });
                newMapObjects.lines.push(polyline);

                // Geofence Label
                const centroid = getPolygonCentroid(googleMapsApi, googlePath);
                if (centroid) {
                    const labelMarker = new googleMapsApi.Marker({
                        position: centroid,
                        map: map,
                        icon: { path: 'M 0,0', strokeOpacity: 0, fillOpacity: 0 },
                        label: { text: name, color: '#000000', fontSize: '12px', fontWeight: 'normal' },
                    });
                    newMapObjects.labels.push(labelMarker);
                }
            }
            // Handle LINESTRING
            else if (geofence.area.startsWith('LINESTRING(')) {
                // Parse "LINESTRING(lat lng, lat lng, ...)"
                const coordsStr = geofence.area.substring(11, geofence.area.length - 1);
                const googlePath = coordsStr.split(', ').map(pair => {
                    const [lat, lng] = pair.split(' ').map(Number);
                    return { lat, lng };
                });

                const polyline = new googleMapsApi.Polyline({
                    path: googlePath,
                    strokeColor: '#3bb2d0',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    map: map,
                });
                newMapObjects.lines.push(polyline);
            }
        });

        mapObjectsRef.current = newMapObjects;

        // Cleanup function for this effect
        return () => {
            Object.values(mapObjectsRef.current).flat().forEach(obj => {
                if (obj && typeof obj.setMap === 'function') { // Check if obj and setMap exist
                    obj.setMap(null);
                }
            });
            mapObjectsRef.current = { polygons: [], lines: [], labels: [] }; // Reset for next run
        };
    // }, [map, googleMapsApi, geoJsonFeatures]); // Re-run when map, API, or geofence features change
    }, [map, googleMapsApi, geofencesData]); // Re-run when map, API, or geofence data change

    return null; // This component manipulates the map directly
};

export default GeofenceMapGoogle;